class Validation {

  static required = buildRule({type: 'required', fn: x => !isEmpty(x)});
  static optional = buildRule({type: 'optional', fn: x => isEmpty(x)});
  static string = buildRule({type: 'string', fn: x => typeof x === 'string'});
  static number = buildRule({type: 'number', fn: x => typeof x === 'number' && x === x});
  static bool = buildRule({type: 'bool', fn: x => typeof x === 'boolean'});
  static date = buildRule({type: 'date', fn: x => x instanceof Date});
  static custom = buildRule;
  private rules: any[]; // TODO: type validation

  constructor(rules) {
    this.rules = rules;
  }

  static pattern = function (reg) {
    return buildRule({
      type: 'pattern',
      fn: x => reg.test(x)
    });
  };

  _processKey(key, rules, value, values) {
    let iterator = rules.values();
    return new Promise(res => {
      const step = function () {
        let next = iterator.next(),
          rule = next.value;
        if (!next.done) {
          Promise.resolve(rule(value, values))
            .then(ruleType => {
              if (ruleType !== "optional") {
                step();
              } else {
                res(null);
              }
            })
            .catch(ruleType => {
              if (ruleType && ruleType !== "optional") {
                res({key: key, value: value, types: [ruleType]});
              } else {
                step();
              }
            });
        } else {
          res(null);
        }
      };
      step();
    });
  }

  _toFinalMap(testsResults) {
    return testsResults.reduce((map, current) => {
      if (typeof current !== 'undefined' && current !== null) {
        map[current.key] = current;
        delete current.key;
      }
      return map;
    }, {});
  }

  _buildTestsAsPromises(values, otherRules) {

    let rules = Object.assign({}, this.rules);

    Object.keys(otherRules).forEach(k => {
      if( !!rules[k]) rules[k] = [];
      rules[k] = rules[k].concat(otherRules[k]);
    });

    return Object.keys(rules).reduce((acc, key) => {
      acc.push(this._processKey(key, rules[key], values[key], values));
      return acc;
    }, []);
  }

  validate(values, otherRules = {}) {
    return Promise.all(this._buildTestsAsPromises(values, otherRules))
      .then(this._toFinalMap)
      .then(results => {
        return Object.keys(results).length === 0 ?
          Promise.resolve(true) :
          Promise.reject(results);
      });
  }

}

function buildRule(specs) {
  const type = specs.type;
  return function (x, data) {
    let result = specs.fn(x, data);
    if (isPromiseLike(result)) {
      return result
        .then((pass) => pass ? Promise.resolve(type) : Promise.reject(type))
        .catch(err => {
          throw err;  // err must bubbles up as it is not validation related
        });
    } else {
      return new Promise((resolve, reject) => {
        specs.fn(x, data) ? resolve(type) : reject(type);
      });
    }
  };
}

function exists(x) {
  return typeof x !== 'undefined' && x !== null;
}

function isEmpty(x) {
  return !exists(x) || (typeof x === 'string' && x.length === 0);
}

function isPromiseLike(x) {
  return x && x.then && typeof x.then === 'function';
}

export default Validation;
